export default (state = false, { type, payload }) => {
  switch (type) {
    case 'OPEN_MANAGE_SUBSCRIPTION':
      return true
    case 'CLOSE_MANAGE_SUBSCRIPTION':
      return false
    default:
      return state
  }
}